import { useQuery } from '@tanstack/react-query';
import {
  fetchAllAttendances,
  fetchTeamAttendances,
  fetchAggregateAttendances,
} from '../api/attendanceApi';
import { attendanceKeys } from './attendanceKeys';

// X3 단계 1b (D6): admin scope read hooks.
// query key namespacing: ['attendances','admin', <scope>, ...args].
// 호출자 갱신은 단계 1d.

export function useAllAttendances(startDate?: string, endDate?: string) {
  return useQuery({
    queryKey: attendanceKeys.adminAll(startDate, endDate),
    queryFn: () => fetchAllAttendances(startDate, endDate),
  });
}

export function useTeamAttendances(teamId: string | undefined) {
  return useQuery({
    queryKey: attendanceKeys.adminTeam(teamId),
    queryFn: () => fetchTeamAttendances(teamId as string),
    enabled: !!teamId,
  });
}

export function useAggregateAttendances(startDate: string, endDate: string) {
  return useQuery({
    queryKey: attendanceKeys.adminAggregate(startDate, endDate),
    queryFn: () => fetchAggregateAttendances(startDate, endDate),
  });
}
